import { render, staticRenderFns } from "./MatricesStudyPlansDetails.vue?vue&type=template&id=b510ed88&scoped=true&"
import script from "./MatricesStudyPlansDetails.vue?vue&type=script&lang=js&"
export * from "./MatricesStudyPlansDetails.vue?vue&type=script&lang=js&"
import style0 from "./MatricesStudyPlansDetails.vue?vue&type=style&index=0&id=b510ed88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b510ed88",
  null
  
)

export default component.exports